import { createContext } from 'react';

const useCcoContext = createContext();
export default useCcoContext;
